// ** Third Party Components
import styled, { css } from "styled-components";

// ** Custom Components
import LocationIcon from "components/icons/LocationIcon";
import LocationIconEnable from "components/icons/LocationIconEnable";
import { ButtonRounded } from "components/layout/Button/ButtonRounded";

// #####################################################

const StyledGeolocationWrapper = styled.div`
	position: absolute;
	right: 1px;
	top: 1px;
	height: calc(2.5rem - 2px);

	button {
		height: 46px;
		width: 46px;
	}

	${({ elipsisRounded }) =>
		elipsisRounded &&
		css`
			button {
				border-radius: var(--dz-sys-input-border-radius) !important;
			}
		`}

	${({ $isLanding }) =>
		$isLanding &&
		css`
			right: 0;
			top: 0;
			button {
				height: 42px;
				width: 42px;
			}
		`}
`;

// #####################################################

const GeoLocationElement = ({
	handleGetGeolocation,
	alwaysLight,
	disabled,
	geolocationEnable,
	showDistance,
	isOpen,
	isLanding,
}) => {
	return (
		<StyledGeolocationWrapper
			$isLanding={isLanding}
			elipsisRounded={!showDistance}
		>
			<ButtonRounded
				alwaysLight={alwaysLight}
				onClick={handleGetGeolocation}
				disabled={disabled}
				$isOpen={isOpen}
				$showDistance={showDistance}
				$isLanding={isLanding}
			>
				{geolocationEnable ? <LocationIconEnable /> : <LocationIcon />}
			</ButtonRounded>
		</StyledGeolocationWrapper>
	);
};

export default GeoLocationElement;

// #####################################################
